<form novalidate #propertyRentalAvailabilitySectionForm="ngForm">
    <tg-row *ngIf="draftLoaded$ | async">
        <tg-col md="8" sm="12">
            <tg-row>
                <tg-col sm="12">
                    <h2>Choose the price and availability of your rental</h2>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4" sm="12">
                    <tg-input-container
                        class="hide-optional-label"
                        label="Rent per week"
                    >
                        <span
                            class="
                                property-rental-availability-section__currency-symbol
                            "
                            >$</span
                        >
                        <input
                            wholeNumber
                            tgTextInput
                            name="pricePerWeek"
                            size="large"
                            (blur)="publish()"
                            [(ngModel)]="
                                draftData.propertyInformation.pricePerWeek
                            "
                            [validation]="
                                validation.propertyInformation.pricePerWeek
                                    | toValidator
                            "
                        />
                    </tg-input-container>
                </tg-col>
                <tg-col md="4" sm="12">
                    <tm-date
                        name="availableFrom"
                        [label]="
                            validation.propertyInformation.availableFrom.name
                        "
                        inputReadonly
                        [minDate]="minDate"
                        [selectedDate]="
                            draftData.propertyInformation.availableFrom
                        "
                        (dateChange)="updateAvailableDate($event)"
                        [validation]="
                            validation.propertyInformation.availableFrom
                        "
                    ></tm-date>
                </tg-col>
            </tg-row>
            <tg-row *ngIf="isEditOrRelistPage">
                <tg-col>
                    <p class="p-secondary-copy">
                        This category includes a listing fee based on rent of
                        the property.
                        <br />
                        <a
                            class="
                                property-rental-availability-section__fee-link
                                h-link-no-visited
                            "
                            target="_blank"
                            href="https://help.trademe.co.nz/hc/en-us/articles/360032007872-Property-fees"
                        >
                            See our fees page for more details.
                        </a>
                    </p>
                </tg-col>
            </tg-row>
            <tg-row *ngIf="feeCalculationFacade.isIncreasePricingTier$ | async">
                <tg-col md="8" sm="12">
                    <tg-info-box>
                        We will update your listing fee according to the new
                        rent value.
                    </tg-info-box>
                </tg-col>
            </tg-row>
            <tg-row *ngIf="isUntilWithdrawn">
                <tg-col md="4" sm="12">
                    <tg-label
                        class="property-rental-availability-section__duration">
                        Listing duration
                    </tg-label>
                    <p class="p-secondary-copy">Until withdrawn</p>
                </tg-col>
            </tg-row>
            <tg-row *ngIf="!isUntilWithdrawn">
                <tg-col md="4" sm="12">
                    <tg-label
                        *ngIf="hasBeenAnExtension"
                        class="property-rental-availability-section__duration">
                        Listing duration
                    </tg-label>
                    <tg-select-container
                        *ngIf="!hasBeenAnExtension"
                        class="hide-optional-label"
                        label="Listing duration"
                    >
                        <select
                            tgSelect
                            name="duration"
                            ngModel
                            (change)="updateAvailableText(); publish()"
                            [(ngModel)]="draftData.propertyInformation.duration"
                            [validation]="
                                validation.propertyInformation.duration
                                    | toValidator
                            "
                        >
                            <option
                                *ngFor="let opt of durationOptions"
                                [ngValue]="opt.value"
                            >
                                {{ opt.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>
            <tg-row *ngIf="!isUntilWithdrawn">
                <tg-col>
                    <p class="p-secondary-copy">
                        Listing ends
                        {{
                            durationDate | tgDateTime: { format: 'long' }
                        }}.<br />
                        Relist for free within 45 days of ending - listing
                        upgrades do not carry over.
                    </p>
                </tg-col>
            </tg-row>
        </tg-col>
        <tg-col md="4" sm="12">
            <property-side-card
                [icon]="sideCardIcon"
                [heading]="sideCardHeading"
                [callToActionText]="sideCardCallToActionText"
                [callToActionLink]="sideCardCallToActionLink"
            >
                {{ sideCardDescription }}
            </property-side-card>
        </tg-col>
    </tg-row>
</form>
